import React from 'react';
import { ReactSVG } from 'react-svg';
import Svg from 'assets/images/ai-assistant/chat-modal-retry/file-error.svg';

type Props = {
  className?: string;
  width?: number;
  height?: number;
};

export const FileErrorIcon = ({ className, width = 104, height = 100 }: Props) => {
  return (
    <ReactSVG
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        display: 'inline-block',
      }}
      src={Svg}
    />
  );
};
